import { Component , OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { TabCtrlService } from './_services/tab-ctrl.service';

import { HomeService } from './_services/home.service';
import { GoogleAnalyticsService } from './_services/google-analytics.service';
import { Subscription } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { AuthenticationService } from './_services';
import { DefaultPageTitle } from './_constants/default-page-title';

export let browserRefresh = false;

declare let ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})


export class AppComponent implements OnInit {
  defaultPageTitle = DefaultPageTitle;
  urlArray = [];
  mainUrl = '';
  error = '';
  gaAccountID: any;
  gaDomainName: any;
  ga4AccountID: any;
  subscription: Subscription;
  displayChat:boolean=false;
  constructor(private tabCtrlService: TabCtrlService, public router: Router, private homeService: HomeService,private authService: AuthenticationService,private gaService: GoogleAnalyticsService) {
    
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });
  }

  
  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    this.authService.setLastTimeVisited(String(new Date().getTime()));
    //localStorage.setItem("lastVisitTime",String(new Date().getTime()));
  }

  @HostListener('document:keypress', ['$event'])
  documentKeyPress(event: KeyboardEvent) { 
    this.authService.setLastTimeVisited(String(new Date().getTime()));
    //localStorage.setItem("lastVisitTime",String(new Date().getTime()));
  }

  ngOnInit() {
    if(window.location.pathname.includes("/viewarticles")){
      let key = "ArticleTitle"+window.location.pathname.split("/")[2];
      let articleTitle = localStorage.getItem(key);
      if(articleTitle !== null){
        this.gaService.setPageTitle(articleTitle);
        localStorage.setItem("InitPage"+window.location.pathname.split("/")[2],window.location.pathname);
        localStorage.removeItem(key);
      }
    }
    else if(window.location.pathname.includes("/article")){
      let key = "ArticleTitle"+window.location.pathname.split("/")[2];
      let articleTitle = localStorage.getItem(key);
      if(articleTitle !== null){
        this.gaService.setPageTitle(articleTitle);
        localStorage.setItem("InitPage"+window.location.pathname.split("/")[2],window.location.pathname);
        localStorage.removeItem(key);
      }
    }
     else {
        this.gaService.updatePageName();
        localStorage.setItem("InitPage"+window.location.pathname.split("/")[2],window.location.pathname);
      
    }
    localStorage.removeItem('showCreateCase');
    this.homeService.getPageTitle().subscribe(value=>{
      console.log("Page Title....",value);
      this.homeService.setPageTitleValue(value);
    },
    (error) =>{
      this.homeService.setPageTitleValue(this.defaultPageTitle);
    }
    );
   
    this.homeService.openChat.subscribe((val:boolean)=>{
      // this.authService.setChatOn("yes");
      this.authService.setValueInConfigAtLocalStorage('isChatOn', 'yes');
      this.displayChat=val;
      console.log("Chat working")
    });
    this.homeService.closeChat.subscribe((val:boolean)=>{
      if(val){
        this.displayChat=false;
      }
    })
   
  //  let isChatOn=this.authService.getChaton();
  setTimeout(()=>{
    let isChatOn =  this.authService.getValueInConfigFromLocalStorage('isChatOn');
    if(isChatOn!==null && isChatOn==="yes"){
      this.displayChat=true;
    }
  },2000);
    this.homeService.cssPathUrl.subscribe((val: string) => {
      console.log("CSS PATH:", val);
      this.homeService.setDynamicStyle(val);
    });
    
    this.tabCtrlService.tabContol();
    this.homeService.gaAccountIDValue.subscribe(message => {
      this.gaAccountID = message;
    });

    this.homeService.gaDomainNameValue.subscribe(message => {
      this.gaDomainName = message;
    });
    this.homeService.ga4AccountIDValue.subscribe(message => {
      this.ga4AccountID = message;
      this.loadGoogleAnalytics(this.gaAccountID, this.gaDomainName, this.ga4AccountID);
    });

  this.homeService.chatbotCssUrl.subscribe((val:string)=>{
    console.log("CHAT CSS PATH:", val);
    this.homeService.setDynamicChatbotStyle(val);
  });
  this.homeService.chatBotPluginScript.subscribe((val:string)=>{
    console.log("ChatBot Plugin Script:", val);
    this.homeService.setDynamicChatbotScript(val);
  });
  
  }

  loadGoogleAnalytics(gaAccountID: string, gaDomainName: string, ga4AccountID: string): void {
    if (ga4AccountID != undefined || ga4AccountID != null || ga4AccountID != "") {
      let valueGA4 = ga4AccountID;
      console.log("GA4 Value",valueGA4)
      const gTagManagerScript = document.createElement('script');
      gTagManagerScript.async = true;
      gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=\'${valueGA4}\'`;
      document.head.appendChild(gTagManagerScript);
      const gaScript = document.createElement('script');
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
         gtag('config', \'${valueGA4}\')
      `;
      document.head.appendChild(gaScript);
    }
  let gaScript = document.createElement('script');
  gaScript.innerText = `(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');`;

    let article = window.location.pathname.split('/')[3] !== "article" ? true : false;
    let viewarticles = window.location.pathname.split('/')[3] !== "viewarticles" ? true : false;
    let urlValue = this.gaService.updateTileUrl();
    if(gaAccountID.includes(",") ){
      let gaIdArray = gaAccountID.split(",");
      let gaDomaniNameArray = gaDomainName.split(",");
      for(let i=0; i<gaIdArray.length; i++){
        if(i==0){
          gaScript.innerText += `ga(\'create\', \'${ gaIdArray[i] }\', \'${ 'com' }\');`;
          gaScript.innerText += `ga(\'create\', \'${ gaIdArray[i] }\', \'${ gaDomaniNameArray[i] }\');`;
          if(article && viewarticles)
          gaScript.innerText += `ga(\'send\', \'pageview\', \'${ urlValue }\');`;
        }else if(i>0){
          gaScript.innerText += `ga(\'create\', \'${ gaIdArray[i] }\', {\'name\':\'com'});`;
          gaScript.innerText += `ga(\'create\', \'${ gaIdArray[i] }\', {\'name\':\'DomainNameTwo\'});`;
          if(article && viewarticles)
          gaScript.innerText += `ga(\'DomainNameTwo.send\', \'pageview\', \'${ urlValue }\');`;
        }
      }
    }else{  
      if(article && viewarticles ){
      gaScript.innerText += `ga(\'create\', \'${ gaAccountID }\', \'${ 'com' }\');`;
      gaScript.innerText += `ga(\'create\', \'${ gaAccountID }\', \'${ gaDomainName }\');`;
      gaScript.innerText += `ga(\'send\', \'pageview\', \'${ urlValue }\');`;
      }
    }
  document.documentElement.firstChild.appendChild(gaScript);
  }

}